module.exports = __webpack_public_path__ + "img/CM.3cfea107.svg";